export const JmEasyActionMode = {
  FINISH: 'finish',
  INTERRUPT: 'interrupt',
  DOWNTIME: 'downtime',
};
